import getConfigFromURL from './getConfigFromURL'
import getLegacyConfig from './getLegacyConfig'

// Captures the websiteUUID
const DYNAMIC_URL_REGEX = new RegExp('^/resource-blocker/([^/]+)')


export default function getConfig({ dataset, id, src }) {
  const srcURL = new URL(src)

  const apiBase = process.env.API_BASE || srcURL.origin

  const config = _getConfig({
    dataset,
    id,
    src: srcURL,
  })

  return {
    apiBase,
    ...config,
  }
}

function _getConfig({ dataset, id, src }) {
  const matches = src.pathname.match(DYNAMIC_URL_REGEX)

  if ( matches ) {
    return getConfigFromURL({
      src,
      websiteUUID: matches[1],
    })
  }

  return getLegacyConfig({
    dataset,
    id,
  })
}
